import { Box, Typography } from '@mui/material';
import { useCurrentuser } from '@uplift/contexts';
import { Formik } from 'formik';
import React from 'react';
import { CancelButton, SubmitButton } from '../../Form';
import { ModalActions, ModalTitle } from '../../Modal';
import { ModalFullPage, ModalFullPageContent } from '../../ModalFullPage';
import { useIsMobile } from '@uplift/hooks';
import { calendarUnsubscribeFromICS } from '@uplift/api';
import { useICSSubscriptionQuery } from '@uplift/queries';
import { useAlert } from '../../AlertProvider';
import { useQueryClient } from '@tanstack/react-query';


export type UnsubscribeGoogleCalendarModalProps = {
  open: boolean;
  onClose: () => void;
};


export const UnsubscribeGoogleCalendarModal: React.FC<UnsubscribeGoogleCalendarModalProps> = (props) => {
  const me = useCurrentuser();
  const queryClient = useQueryClient();
  const alert = useAlert();
  const isMobile = useIsMobile();
  const { data: icsSubscription } = useICSSubscriptionQuery(me.id);

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      onSubmit={async () => {
        try {
          await calendarUnsubscribeFromICS();
          await queryClient.invalidateQueries({ queryKey: [ 'icsSubscription', me.id ] });
          props.onClose();

          alert.success(`${icsSubscription?.title} successfully disconnected.`);
        } catch (err) {
          alert.error(
            <span>
              There was a problem disconnecting your<br />
              {icsSubscription?.title}. Try again or contact<br />
              <strong>help@joinuplift.co</strong>
            </span>
          );
        }
      }}
    >
      <ModalFullPage open={props.open} onClose={props.onClose} maxWidth="sm" mobileOnly transition>
        <ModalTitle onClose={props.onClose}>
          Disconnect {icsSubscription?.title}?
        </ModalTitle>
        <ModalFullPageContent dividers={isMobile}>
          <Box px={1} pb={2}>
            <Typography>
              Disconnecting your Google Calendar will remove all events associated with this calendar and your <strong>Matching Availability will no longer be automatically updated</strong>.
              You can always reconnect another Google Calendar at a later time.
            </Typography>
          </Box>
        </ModalFullPageContent>
        <ModalActions>
          <CancelButton onClick={props.onClose}>Keep calendar</CancelButton>
          <SubmitButton color="error">Disconnect calendar</SubmitButton>
        </ModalActions>
      </ModalFullPage>
    </Formik>
  );
};
